import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  chart: {
    padding: theme.spacing(2),
  },
  resultsRoot: {
    backgroundColor: "#f4f7fb",
    minHeight: "calc(100vh - 64px)",
    padding: theme.spacing(3),
  },
  toolbarActions: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
  },
  statusChip: {
    color: "#ffffff",
    fontWeight: 700,
  },
  completedChip: {
    backgroundColor: "#2e7d32",
  },
  progressChip: {
    backgroundColor: "#c62828",
  },
  summaryGrid: {
    marginBottom: theme.spacing(2),
  },
  summaryCard: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid #dbe7f5",
    borderLeft: "5px solid #2196f3",
    borderRadius: 8,
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
    height: "100%",
  },
  summaryCardResidents: {
    borderLeftColor: "#2196f3",
  },
  summaryCardVoted: {
    borderLeftColor: "#4caf50",
  },
  summaryCardPending: {
    borderLeftColor: "#f44336",
  },
  summaryCardPercent: {
    borderLeftColor: "#ff9800",
  },
  summaryContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    height: "stretch",
    minHeight: 86,
    padding: theme.spacing(2, 2.5),
  },
  summaryMain: {
    minWidth: 0,
  },
  summaryAction: {
    fontWeight: 400,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  summaryDivider: {
    margin: theme.spacing(0, 2.5),
  },
  summaryFooter: {
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(0.75, 1.5, 1.25),
  },
  summaryIcon: {
    alignItems: "center",
    borderRadius: "50%",
    display: "flex",
    height: 36,
    justifyContent: "center",
    width: 36,
  },
  summaryIconResidents: {
    color: "#2196f3",
  },
  summaryIconVoted: {
    color: "#4caf50",
  },
  summaryIconPending: {
    color: "#f44336",
  },
  summaryIconPercent: {
    color: "#ff9800",
  },
  summaryLabel: {
    color: "#34495e",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 0,
    marginBottom: theme.spacing(0.75),
  },
  summaryValue: {
    color: "#1f2937",
    fontWeight: 800,
    lineHeight: 1,
  },
  sectionTitle: {
    color: "#142c57",
    fontWeight: 800,
    margin: theme.spacing(0, 0, 0.5),
  },
  sectionSubtitle: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2.5),
  },
  resultCard: {
    border: "1px solid rgba(0, 97, 233, 0.14)",
    borderRadius: 8,
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
    height: "100%",
    overflow: "hidden",
  },
  resultHeader: {
    backgroundColor: "#142c57",
    padding: theme.spacing(1.5, 2),
  },
  resultHeaderTitle: {
    color: "#ffffff",
    fontSize: 15,
    fontWeight: 700,
  },
  resultContent: {
    padding: theme.spacing(1.5, 2, 2),
  },
  chartBox: {
    height: 180,
    margin: "0 auto",
    maxWidth: 240,
    position: "relative",
  },
  generalChartGrid: {
    marginBottom: theme.spacing(3),
  },
  questionGrid: {
    alignItems: "stretch",
  },
  tableTitle: {
    color: "#334155",
    fontSize: 14,
    fontWeight: 700,
    margin: theme.spacing(2, 0, 1),
  },
  percentageCell: {
    minWidth: 120,
  },
  percentageBar: {
    borderRadius: 8,
    height: 8,
    marginTop: theme.spacing(0.75),
  },
  participantsAction: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
  },
  participantsCount: {
    color: "#1f2937",
    fontWeight: 700,
    minWidth: 18,
  },
  fin: {
    backgroundColor: "#95D890",
    padding: "10px",
    alignContent: "center",
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
  },
  continue: {
    backgroundColor: "#e74c3c",
    padding: "10px",
    alignContent: "center",
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
  },
}))
export default useStyles
